import { Component, OnInit /** Output, Input, EventEmitter */ } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DealerService } from '../dealer-service/dealer.service';
import { ListaBase } from '././../../../../shared/crud/ListaBase';
import { EstruturaGridViewBuilder } from '././../../../../shared/gridview/EstruturaGridViewBuilder';
import { Parametro } from '././../../../../shared/service-base/parametro';

@Component({
  selector: 'app-dealer-lista',
  templateUrl: '../../template/lista.html',
  styleUrls: ['./dealer-lista.component.css']
})
export class DealerListaComponent
  extends ListaBase
  implements OnInit {

  visualizarTotalRegistros: boolean;
  exibirBotaoDetalhes: boolean;

  constructor(service: DealerService, toastr: ToastrService, router: Router) {
    super(service, toastr, router);
    this.visualizarTotalRegistros = true;
    this.listagemComPaginacao = true;
    this.quantidadeRegistrosPorPagina = 10;
    this.exibirBotaoDetalhes = true;
  }

  ngOnInit() {
    this.buscar();
    this.estrutura = new EstruturaGridViewBuilder()
      .addColuna('nome', 'parametros.dealer.descricao')
      .addColuna('cnpj', 'parametros.dealer.CNPJ')
      .addColuna('codigo', 'Dealer code')
      .addColunaBooleanW('status', 'parametros.dealer.ativo', '100px')
      .build();
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.descricao
      || this.filtros.cnpj
      || this.filtros.codigo;
  }

  protected carregarModel(registro: any): Promise<any> {

    const parametros: Parametro[] = [];
    const param = new Parametro('id', registro.registro.id);
    parametros.push(param);

    this.carregando = true;

    return this.service.get(parametros)
      .then(res => {
        const retorno: any = {};
        retorno.novoCadastro = false;
        retorno.registro = res.dados[0];
        this.carregando = false;

        return retorno;
      })
      .catch(error => {
        this.tratarErro('Não foi posível carregar o registro', 'Erro', error);
      })
  }
}
